export default __webpack_public_path__ + "static/media/234.feda02bc.png";